import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const VendorCOAListPageUI = ({context, chartOfAccountList, errorList,
    // modes
    updateMode, selectedList, unSelectedList, updatingCOA,
    // event handlers
    onRefreshClick, onUpdateClick, onCancelClick, onSelect, onUnSelect
  }) =>
  <SuperUserSettingsPageUI context={context} className='pg_su_v_coa' topnav='settings' backLink='/su/settings'
    headerText='Vendor bill COAs' centered={!chartOfAccountList && !errorList} page='vbCOAs'
  >
    {
      !chartOfAccountList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      chartOfAccountList && chartOfAccountList.length !== 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/su/settings' titleText='Vendor bill COAs' />
        {
          !updateMode &&
          <COAListUI
            context={context}
            chartOfAccountList={chartOfAccountList}
            onRefreshClick={onRefreshClick}
            onUpdateClick={onUpdateClick}
            onSelect={onSelect}
            onUnSelect={onUnSelect}
          />
        }
        {
          updateMode &&
          <COAEditUI
            context={context}
            selectedList={selectedList}
            unSelectedList={unSelectedList}
            onCancelClick={onCancelClick}
            onSelect={onSelect}
            onUnSelect={onUnSelect}
            updatingCOA={updatingCOA}
          />
        }
      </div>
    }
  </SuperUserSettingsPageUI>

  const COAListUI = ({context, chartOfAccountList, onRefreshClick, onUpdateClick}) =>
    <div>
      <LRTableActionsUI location='top'
        left={
          <ActionLeftUI context={context} onRefreshClick={onRefreshClick} onUpdateClick={onUpdateClick} />
        }
        right={<span />}
      />
      <div>
        {
          chartOfAccountList.filter(coa => coa.vendorPaymentEnabled).map((coa, i) =>
            <div key={i} className='g_flex_h g_flex_left'>
              <span>{coa.chartOfAccountName}</span>
              <span className='g_muted g_m_left_50'>{coa.coaCategoryName}</span>
            </div>
          )
        }
      </div>
    </div>

  const COAEditUI = ({context, selectedList, unSelectedList, onCancelClick, onSelect, onUnSelect, updatingCOA}) =>
    <div>
      <LRTableActionsUI location='top'
        left={<span />}
        right={
          <ButtonUI label='Done' onClick={onCancelClick} />
        }
      />
      <div>
        {
          selectedList.map((coa, i) =>
            <div key={i} className='g_flex_h g_flex_left'>
              <input type="checkbox" data-row-id={coa.chartOfAccountCode} onChange={onUnSelect} checked={true} />
              <span className='g_m_left_50'>{coa.chartOfAccountName}</span>
              <span className='g_muted g_m_left_50'>{coa.coaCategoryName}</span>
              <SpinnerUI reserveSpace={true} show={coa.chartOfAccountCode == updatingCOA} />
            </div>
          )
        }
        <hr />
        {
          unSelectedList.map((coa, i) =>
            <div key={i} className='g_flex_h g_flex_left'>
              <input type="checkbox" data-row-id={coa.chartOfAccountCode} onChange={onSelect} checked={false} />
              <span className='g_m_left_50'>{coa.chartOfAccountName}</span>
              <span className='g_muted g_m_left_50'>{coa.coaCategoryName}</span>
              <SpinnerUI reserveSpace={true} show={coa.chartOfAccountCode == updatingCOA} />
            </div>
          )
        }
      </div>
    </div>

  const ActionLeftUI = ({context, onRefreshClick, onUpdateClick}) =>
    <div className='g_flex_h'>
      <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
      <IconButtonUI icon='icon-pencil' onClick={onUpdateClick} />
    </div>

export default VendorCOAListPageUI
